import axios from 'axios';

const BASE = import.meta.env.VITE_API_URL ?? 'https://api.ojpschools.com.ng/api/v1';

export const api = axios.create({
  baseURL: BASE,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

function readToken(): string | null {
  const raw = localStorage.getItem('ojp-auth');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      const token = parsed?.state?.token;
      if (typeof token === 'string' && token.length > 10) return token;
    } catch { /* fall through */ }
  }
  return localStorage.getItem('token') || localStorage.getItem('auth_token') || null;
}

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Files: with a JSON content type axios turns FormData into JSON and drops the files. Let the browser set multipart.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) config.headers.delete('Content-Type');
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 503 && error.response?.data?.maintenance) {
      window.dispatchEvent(new CustomEvent('ojp:maintenance', { detail: error.response.data.message }));
    }
    const sentAuth = Boolean(error.config?.headers?.Authorization);
    if (status === 401 && sentAuth) {
      localStorage.removeItem('ojp-auth');
      localStorage.removeItem('token');
      localStorage.removeItem('auth_token');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  },
);
